import { createStore, combineReducers, applyMiddleware } from "redux";
import * as reducers from "./features";
import storeInitialState from "./storeInitialState";
import { multiClientMiddleware } from 'redux-axios-middleware';
import { axiosClient, oneMapSGClient } from "./middlewares";
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

const rootReducer = combineReducers(reducers);

const store = createStore(
  rootReducer,
  storeInitialState as any,
  composeWithDevTools(
    applyMiddleware(
      multiClientMiddleware({
        default: { client: axiosClient },
        oneMapSG: { client: oneMapSGClient }
      })
    )
  )
);

export type RootState = ReturnType<typeof store.getState>;

// Stamps the current idempotency key onto every place-order request body.
// The key is generated once on checkout page load (see idempotencyKey slice),
// so accidental double-clicks or transport-level retries hit the server with
// the same key and the server can dedupe. Scoped to POST + `order_details` in
// the body so PUT updates are unaffected.
axiosClient.interceptors.request.use((config) => {
  const method = config.method?.toLowerCase();
  if (
    method === "post" &&
    config.data &&
    typeof config.data === "object" &&
    "order_details" in config.data
  ) {
    const key = (store.getState() as any).idempotencyKey;
    if (key) {
      config.data = { ...config.data, idempotency_key: key };
    }
  }
  return config;
});

export { store };
